import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { hasPrivilege } from "../api/token";
import BoardCard from "../components/BoardCard";

export default function ManufactureAssign() {
  const navigate = useNavigate();
  const params = useParams();
  const assign = hasPrivilege('assign');

  useEffect(() => {
    if (!assign) {
      navigate("/");
    }
  }, [navigate, assign])

  if (assign) {
    const editable = true;
    const ident = {
      id_spare: params.id,
      id_stock: params.id2
    };
    const layer = 'assign';

    return (
      <div>
        <BoardCard editable={editable} ident={ident} layer={layer}/>
      </div>
    )
  }
}
